import axios from 'axios'

const state = {
  tags: [],
  filteredTags: [],
  // selectedTags: []
}

const getters = {
  getTagNames () {
    return state.tags.map(tag => tag.name)
  }
}

const mutations = {
  setTags (state, tags) {
    state.tags = tags
  },
  setFilteredTags (state, tags) {
    state.filteredTags = tags
  },
  // setSelectedTags (state, tags) {
  //   state.selectedTags = tags
  // },
  addTag (state, tag) {
    state.tags.push(tag)
  },
  updateTag (state, payload) {
    const index = state.tags.findIndex(item => item.id === payload.id)
    if (index !== -1) state.tags.splice(index, 1, payload)
  },
  deleteTag (state, id) {
    var index = state.tags.findIndex(tag => tag.id === id)
    state.tags.splice(index, 1)
  }
}

const actions = {
  getTagsList (context) {
    return axios.get('/api/tags')
      .then(response => {
        context.commit('setTags', response.data)
      })
      .catch(e => { console.log(e) })
  },
  createTag (context, payload) {
    return axios.post('/api/tags/', payload)
      .then(response => {
        context.commit('addTag', response.data)
      })
      .catch(e => { console.log(e) })
  },
  updateTag (context, payload) {
    return axios.patch(`/api/tags/${payload.id}/`, payload)
      .then(response => {
        context.commit('updateTag', response.data)
      })
      .catch(e => { console.log(e) })
  },
  mergeTag (context, payload) {
    return axios.post(`/api/tags/${payload.id}/merge_tags/`, payload)
      .then(response => {
        context.commit('deleteTag', payload.id)
      })
      .catch(e => { console.log(e) })
  },
  deleteTag (context, payload) {
    return axios.delete(`/api/tags/${payload.id}/`, payload)
      .then(response => {
        context.commit('deleteTag', payload.id)
      })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
